import { VhcRecordLogService } from 'api/generated';
import { formatErrorMessage, QueryError } from 'features/shared/model';
import { useMutation, UseMutationOptions } from 'react-query';
import { toast } from 'react-toastify';

export type CreateVhcRecordVideoInput = {
  id: number;
  formData?: {
    Video: Blob;
  };
};

export const useCreateVhcRecordVideoMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof VhcRecordLogService.postVhcRecordsVideos>>,
      QueryError,
      CreateVhcRecordVideoInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ id: id, formData: formData }: CreateVhcRecordVideoInput) =>
      VhcRecordLogService.postVhcRecordsVideos(id, formData),
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully created!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
